import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

export const CardTableShell = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: ${p => p.maxWidth || "98.625rem"};
    min-height: ${p => p.minHeight || "auto"};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    background: ${portalColors.surface};
    overflow: hidden;
    box-shadow: ${portalColors.shadow};
    box-sizing: border-box;
`;

export const CardTableToolbar = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
    width: 100%;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid ${portalColors.border};
    box-sizing: border-box;
    background: ${portalColors.surface};

    @media (max-width: 900px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const CardTableSelectAllControl = styled.div`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-left: 1rem;
    margin-top: 0.75rem;
`;

export const CardTableRows = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${p => p.gap || "1rem"};
    padding: ${p => p.padding || "1.25rem"};
    flex-grow: 1;
    overflow: auto;
    max-height: ${p => p.maxHeight || "48rem"};
    min-height: ${p => p.minHeight || "auto"};
    background: ${portalColors.surface};
`;

export const CardTableRow = styled.div`
    display: grid;
    grid-template-columns: ${p => p.columns || "1fr"};
    gap: ${p => p.gap || "0.75rem"};
    width: 100%;
    min-width: ${p => p.minWidth || "0"};
    padding: ${p => p.padding || "1rem"};
    box-sizing: border-box;
    border: 1px solid ${portalColors.border};
    border-radius: 12px;
    background: ${p => p.selected ? "var(--calendar-selected-cell-bg, rgba(91, 110, 245, 0.12))" : portalColors.surface};
    color: ${portalColors.text};
    transition: transform 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;

    &:hover {
        border-color: ${portalColors.borderStrong};
        box-shadow: 0 14px 28px rgba(29, 42, 89, 0.09);
        transform: translateY(-1px);
    }

    @media (max-width: 900px) {
        min-width: 0;
        grid-template-columns: 1fr;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover {
            transform: none;
        }
    }
`;

export const CardTableCell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: ${p => p.alignItems || "flex-start"};
    gap: ${p => p.gap || "0"};
    min-width: 0;
    width: 100%;
`;

export const CardTableCellHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: ${p => p.justifyContent || "flex-start"};
    gap: 0.75rem;
    padding-bottom: 0.6rem;
    color: ${portalColors.mutedText};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const CardTableTextCard = styled.div`
    width: 100%;
    min-height: ${p => p.minHeight || "140px"};
    height: ${p => p.variant === "media" ? "auto" : "100%"};
    aspect-ratio: ${p => p.variant === "media" ? "16 / 9" : "auto"};
    overflow: hidden;
    background: ${p => p.variant === "media" ? portalColors.surfaceSoft : portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    box-sizing: border-box;
    display: ${p => p.variant === "media" ? "flex" : "block"};
    align-items: center;
    justify-content: center;

    img,
    video {
        width: 100%;
        height: 100%;
        max-width: 100%;
        object-fit: contain;
        object-position: center;
        display: block;
    }
`;

export const CardTableText = styled.div`
    padding: ${p => p.padding || "1rem"};
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.45;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${p => p.clamp || 5};
    overflow: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
`;

export const CardTableEmptyState = styled.div`
    min-height: ${p => p.minHeight || "14rem"};
    display: grid;
    place-items: center;
    gap: 0.5rem;
    padding: 2rem;
    border: 1px dashed ${portalColors.borderStrong};
    border-radius: 12px;
    background: ${portalColors.surfaceSoft};
    color: ${portalColors.mutedText};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.5;
    text-align: center;
    box-sizing: border-box;
`;

export default CardTableShell;
